import {BasicListReducerStateType} from "../BasicReducerState";
import {IProjectLogEntry} from "../../models/projects/ProjectLog";
import {
    FETCH_OUTGOING_INVOICES_PROJECT_LOG,
    FETCH_OUTGOING_INVOICES_PROJECT_LOG_ERROR,
    FETCH_OUTGOING_INVOICES_PROJECT_LOG_SUCCESS,
    OutgoingInvoiceProjectLogViewActionTypes
} from "../../actions/account-book/OutgoingInvoiceProjectLogActions";
import {
    errorFetchingRequestState, RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";


export interface OutgoingInvoiceProjectLogState {
    entries: {
        [ key: number ]: {
            totalEntries: number
            current: IProjectLogEntry[]
            request: RequestState
        }
    }

}

const initialState: OutgoingInvoiceProjectLogState = {
    entries: {}
};

export function OutgoingInvoiceProjectLogReducer(
    state: OutgoingInvoiceProjectLogState = initialState,
    action: OutgoingInvoiceProjectLogViewActionTypes
) {

    switch( action.type ) {
        case FETCH_OUTGOING_INVOICES_PROJECT_LOG:
            return {
                ...state,
                entries: {
                    [ action.outgoingInvoiceId.rawValue ]: {
                        totalEntries: 0,
                        current: [],
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_OUTGOING_INVOICES_PROJECT_LOG_SUCCESS:
            return {
                entries: {
                    ...state.entries,
                    [ action.outgoingInvoiceId.rawValue ]: {
                        totalEntries: action.payload.totalEntries,
                        current: action.payload.entries,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_OUTGOING_INVOICES_PROJECT_LOG_ERROR:
            return {
                entries: {
                    ...state.entries,
                    [ action.outgoingInvoiceId.rawValue ]: {
                        totalEntries: 0,
                        current: [],
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        default:
            return state;
    }

}